// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__s6HBY","footer":"NavbarSimple_footer__3vx8p","link":"NavbarSimple_link__EHLvk","linkIcon":"NavbarSimple_linkIcon__lPm7v"};